import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/firebase-messaging";
import "firebase/functions";
import "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASURAMENT_ID
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

// firebase utils
const db = firebase.firestore();
const functions = firebase.functions();

const firestoreTimestamp = firebase.firestore.Timestamp;
const auth = firebase.auth();

if (
  process.env.NODE_ENV === "development" &&
  process.env.VUE_APP_USE_FIREBASE_EMULATOR !== "false"
) {
  functions.useFunctionsEmulator(process.env.VUE_APP_EMULATOR_URL);
}

if (firebase.messaging.isSupported()) {
  window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register(`/firebase-messaging-sw.js`, {
          scope: "firebase-cloud-messaging-push-scope"
        })
        .then(function(registration) {
          const messaging = firebase.messaging();
          messaging.useServiceWorker(registration);

          messaging
            .requestPermission()
            .then(function() {
              return messaging.getToken();
            })
            .then(token => {
              // eslint-disable-next-line
              console.log(token);
              // store token in localstorage
              localStorage.setItem("fcm-token", token);

              // background handler on message receive event
              messaging.onMessage(payload => {
                const notificationOptions = {
                  body: payload.data.body,
                  icon: payload.notification.icon
                };
                registration.showNotification(
                  payload.data.title,
                  notificationOptions
                );
              });

              // Callback fired if Instance ID token is updated.
              messaging.onTokenRefresh(() => {
                messaging
                  .getToken()
                  .then(refreshedToken => {
                    localStorage.setItem("fcm-token", refreshedToken);
                    // eslint-disable-next-line
                    console.log("Token refreshed.");
                  })
                  .catch(err => {
                    // eslint-disable-next-line
                    console.log("Unable to retrieve refreshed token ", err);
                  });
              });
            })
            .catch(e => {
              // eslint-disable-next-line
              console.error(e);
            });
        })
        .catch(function(err) {
          // eslint-disable-next-line
          console.error("ServiceWorker registration failed: ", err);
        });
    }
  });
}

export { db, functions, firebase, firestoreTimestamp, auth };
